const members = [
  {
    id: "155",
    name: "Om Kumar",
    nickname: "0K",
    designation: "Team Manager",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:okhere21@gmail.com",
    linkedin: "https://www.linkedin.com/in/om-kumar-75517926a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: "https://github.com/W-OK-E"
  },
  {
    id: "159",
    name: "Davasam Karthikeya",
    nickname: "Davawesome",
    designation: "Technical Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:davasamkarthikeya@gmail.com",
    linkedin: "https://www.linkedin.com/in/davasam-karthikeya",
    github: "https://github.com/Karthikeya819"
  },
  {
    id: "156",
    name: "Mrigaank Mouli",
    nickname: "ZER0\u00B0",
    designation: "Research and Development Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:sufy1707@gmail.com",
    linkedin: "https://in.linkedin.com/in/mrigaank-mouli-676120287",
    github: null
  },
  {
    id: "154",
    name: "Janak Shah",
    nickname: ".js",
    designation: "AI Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:janak.sh41@gmail.com",
    linkedin: "https://www.linkedin.com/in/janaks1/",
    github: "https://github.com/codegallivant"
  },
  {
    id: "160",
    name: "Kartikeya Singh",
    nickname: "Karthicc",
    designation: "Sensing and Automation Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "",
    linkedin: null,
    github: null
  },
  {
    id: "165",
    name: "Anvith Choudhary Jasti",
    nickname: "AN-Sys",
    designation: "Mechanical Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "",
    linkedin: null,
    github: null
  },
  {
    id: "170",
    name: "Ashwin Modey",
    nickname: "Ashwink;)",
    designation: "Management Head",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:ashwinmodey05@gmail.com",
    linkedin: "https://www.linkedin.com/in/ashwin-modey-2274b220b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: null
  },
  {
    id: "153",
    name: "Asmit Paul",
    nickname: "AS*MIT",
    designation: "Senior AI Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:hiasmitpaul@gmail.com",
    linkedin: null,
    github: "http://github.com/asmit-mit"
  },
  {
    id: "157",
    name: "Tanmay Singh Bains",
    nickname: "GAINS",
    designation: "Senior AI Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:tanmaybains.2005@gmail.com",
    linkedin: "https://www.linkedin.com/in/tanmay-bains-677576281",
    github: "https://github.com/TanmayBnz"
  },
  {
    id: "161",
    name: "Kaustubh Pandey",
    nickname: "Buck-LOL",
    designation: "Senior Sensing and Automation Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:kaustubhofficial.kp@gmail.com",
    linkedin: "https://www.linkedin.com/in/kaustubh-pandey-b42082218/?originalSubdomain=in",
    github: "https://github.com/KPkaustubhKP"
  },
  {
    id: "162",
    name: "Sachin Sushil",
    nickname: "shawarma",
    designation: "Senior Sensing and Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:sachinctl@protonmail.com",
    linkedin: "https://in.linkedin.com/in/sachin-sushil",
    github: "https://github.com/schctl"
  },
  {
    id: "163",
    name: "Sudeep Sharma",
    nickname: "WattraSudip",
    designation: "Senior Sensing and Automation Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:sudeep220604@gmail.com",
    linkedin: "https://www.linkedin.com/in/sudeep-sharma-8a4624248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: null
  },
  {
    id: "164",
    name: "Aadya Jha",
    nickname: "MOTORS",
    designation: "Senior Mechanical Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:Aadyaj0305@gmail.com",
    linkedin: null,
    github: "https://github.com/Aadya03"
  },
  {
    id: "168",
    name: "Mohit Nambiar",
    nickname: "6 FT. UNDER",
    designation: "Senior Mechanical Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:mohitnambiar80@gmail.com",
    linkedin: "https://www.linkedin.com/in/mohit-nambiar-b8b6241bb?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: null
  },
  {
    id: "169",
    name: "Aditi Jain",
    nickname: "adeity",
    designation: "Senior Management Member",
    imageExt: ".jpg",
    facebook: null,
    mail: "mailto:jainaditi2005@gmail.com",
    linkedin: "https://www.linkedin.com/in/aditijain11/",
    github: "https://github.com/aditi116"
  },
  {
    id: "171",
    name: "Aditya Singh Waldia",
    nickname: "Waldo",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:asw311219@gmail.com",
    linkedin: "https://www.linkedin.com/in/aditya-waldia-9b45042a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: "https://github.com/InfiniteEccentricity"
  },
  {
    id: "172",
    name: "Asavari Kaushal",
    nickname: "Raspberrypie",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:asavarikaushgal@gmail.com",
    linkedin: null,
    github: null
  },
  {
    id: "173",
    name: "Chirag Rao K V",
    nickname: "RaOS",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:chirag.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "174",
    name: "Hariharan VS",
    nickname: "VScode",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:vshariharan3@gmail.com",
    linkedin: "https://www.linkedin.com/in/hariharan-vs-36570832a/",
    github: "https://github.com/vsHariharan03"
  },
  {
    id: "175",
    name: "Jasmine Pannu",
    nickname: "Jazzy",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:jasmine.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "176",
    name: "Michelle Maria Andrade",
    nickname: "Missandry",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:michelle.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "177",
    name: "Onas Chaturvedi",
    nickname: "Loondry",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:https://github.com/OnasChaturvedi",
    linkedin: "https://www.linkedin.com/in/onas-chaturvedi-18390031b/",
    github: "https://www.linkedin.com/in/onas-chaturvedi-18390031b/"
  },
  {
    id: "178",
    name: "Sparsh Agrawal",
    nickname: "Spookie",
    designation: "Artiificial Intelligence Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:agrawalsparsh6@gmail.com",
    linkedin: "https://www.linkedin.com/in/sparsh-agrawal-05b34925b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    github: "https://github.com/SparshA6"
  },
  {
    id: "179",
    name: "Akshat Pankaj Kakade",
    nickname: ".apk",
    designation: "Sensing & Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:akshat.kakade@gmail.com",
    linkedin: "https://www.linkedin.com/in/akshat-kakade",
    github: "https://github.com/Akshat-Kakade"
  },
  {
    id: "180",
    name: "Aryan Pagaria",
    nickname: "Ar-yawn",
    designation: "Sensing & Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:aryan.pagaria@gmail.com",
    linkedin: "https://www.linkedin.com/in/aryan-pagaria-53495b319?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_appnull",
    github: null
  },
  {
    id: "181",
    name: "Shubh Kesarwani",
    nickname: "Lose My Mind",
    designation: "Sensing & Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:shubh2.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "182",
    name: "Soham Saxena",
    nickname: "S.O.S",
    designation: "Sensing & Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:soham6.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "183",
    name: "Taman Raja Kochi",
    nickname: "Verilong",
    designation: "Sensing & Automation Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:Taman.mitmpl2024@leaner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "184",
    name: "Anant Shankar Gupta",
    nickname: "BBL",
    designation: "Mechanical Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:anant4.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "185",
    name: "Anup Kamath",
    nickname: "MUMMY",
    designation: "Mechanical Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:anup.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "186",
    name: "Bhuvan Chand Rayani",
    nickname: "INOX",
    designation: "Mechanical Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:rayani.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "187",
    name: "Preet Shah",
    nickname: "NoLaptop?",
    designation: "Mechanical Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:preet.mitmpl2024@learner.manipal.edu",
    linkedin: null,
    github: null
  },
  {
    id: "188",
    name: "Yash Ralhan",
    nickname: "ICE4LYF",
    designation: "Mechanical Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:ralhanyash9@gmail.com",
    linkedin: "https://www.linkedin.com/in/yash-ralhan-539672314?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    github: "https://github.com/yashhorseman"
  },
  {
    id: "189",
    name: "Astin Dsouza",
    nickname: "Dihsouza",
    designation: "Management Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:astindsouza27@gmail.com",
    linkedin: "https://www.linkedin.com/in/astin-dsouza-430858233/",
    github: null,
  },
  {
    id: "190",
    name: "Bedobrata Saikia",
    nickname: "Bedo_Dodo",
    designation: "Management Member",
    imageExt: ".gif",
    facebook: null,
    mail: "mailto:bedobrata.saikia@gmail.com",
    linkedin: "https://www.linkedin.com/in/bedobrata-saikia-70518225b/",
    github: null
  },
  {
    id: "191",
    name: "Parth Chopra",
    nickname: "Chopra-G",
    designation: "Management Member",
    imageExt: ".png",
    facebook: null,
    mail: "mailto:parth12.mitmpl2024@leaner.manipal.edu",
    linkedin: null,
    github: null
  },
];

export default members;
